import {
  CreateOneWorkflowDto,
  UpdateOneWorkflowDto,
  WorkflowDto,
} from "@babackapp/private-api-client/types";
import { createContext, FC, PropsWithChildren, useContext } from "react";

type WorkflowContextType = {
  shopId: string;
  workflowList: WorkflowDto[];
  onAddWorkflow: (workflowData: CreateOneWorkflowDto) => Promise<WorkflowDto>;
  onRemoveWorkflow: (workflowId: string) => void;
  onUpdateWorkflow: (p: {
    body: UpdateOneWorkflowDto;
    workflowId: string;
  }) => Promise<WorkflowDto>;
};

type WorkflowContextProviderProps = PropsWithChildren<WorkflowContextType>;

const WorkflowListContext = createContext<WorkflowContextType | undefined>(
  undefined,
);

export const WorkflowsPageProvider: FC<
  PropsWithChildren<WorkflowContextProviderProps>
> = ({ children, ...props }) => {
  return (
    <WorkflowListContext.Provider
      value={{
        ...props,
      }}
    >
      {children}
    </WorkflowListContext.Provider>
  );
};

export const useWorkflowsContext = () => {
  const context = useContext(WorkflowListContext);
  if (context === undefined) {
    throw new Error("useWorkflowContext must be used within a WorkflowContext");
  }
  return context;
};
